"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _homepageCarSelector = require("@mmc/homepage-car-selector");
var _textBlock = require("@mmc/text-block");
var _vehicleTabs = _interopRequireDefault(require("../styles/vehicle-tabs.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * ## VehicleTabs - component
 *
 * A component that uses incoming data to construct a form
 */

// We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non r

var vehcileTabInstances = 0;
var VehicleTabs = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(VehicleTabs, _React$Component);
  function VehicleTabs(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var components = props.components || [];
    vehcileTabInstances++;
    var CarSelector = components.filter(function (component) {
      return component.resourceType === 'CarSelector_1_0_0';
    })[0];
    var vehicleMap = [];
    var selectedVehicle = null;
    if (CarSelector) {
      if (CarSelector.productTile) {
        if (CarSelector.productTile.length > 0) {
          vehicleMap = CarSelector.productTile.map(function (vehicle) {
            return vehicle.code + "_" + vehicle.year;
          });
        }
      }
    }
    _this.state = {
      selectedVehicle: selectedVehicle,
      vehicleMap: vehicleMap
    };
    _this.handleChangeVehicle = _this.handleChangeVehicle.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = VehicleTabs.prototype;
  _proto.handleChangeVehicle = function handleChangeVehicle(formPos, value) {
    this.setState(function () {
      return {
        selectedVehicle: value[0]
      };
    });
  };
  _proto.renderCarSelector = function renderCarSelector(components) {
    var CarSelector = components.filter(function (component) {
      return component.resourceType === 'CarSelector_1_0_0';
    })[0];
    if (CarSelector) {
      return /*#__PURE__*/_react["default"].createElement(_homepageCarSelector.HomepageCarSelector, {
        handleChangeEvent: this.handleChangeVehicle,
        selectedValue: this.state.selectedVehicle,
        data: CarSelector,
        theme: this.props.theme,
        tabId: "vehicle-tabs-" + vehcileTabInstances
      });
    }
    return null;
  };
  _proto.renderTextBlock = function renderTextBlock(components) {
    var _this2 = this;
    var _this$state = this.state,
      selectedVehicle = _this$state.selectedVehicle,
      vehicleMap = _this$state.vehicleMap;
    var TextBlocks = components.filter(function (component) {
      return component.resourceType === 'TextBlock_1_0_0';
    });
    if (TextBlocks.length > 0) {
      var selectedVehcileIndex = vehicleMap.findIndex(function (vehicleCodeAndYear) {
        return selectedVehicle === vehicleCodeAndYear;
      });
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, TextBlocks.map(function (textBlock, i) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          key: i,
          className: "" + _vehicleTabs["default"].textBlock,
          id: "vehicle-tabs-" + vehcileTabInstances + "-panel-" + i,
          "aria-labelledby": "vehicle-tabs-" + vehcileTabInstances + "-tab-" + i,
          "aria-hidden": selectedVehcileIndex !== i,
          "aria-expanded": selectedVehcileIndex === i
        }, /*#__PURE__*/_react["default"].createElement(_textBlock.TextBlock, {
          key: i,
          data: textBlock,
          theme: _this2.props.theme
        }));
      }));
    }
    return null;
  };
  _proto.render = function render() {
    var components = this.props.components;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _vehicleTabs["default"].vehicleTabs
    }, this.renderCarSelector(components), this.renderTextBlock(components));
  };
  return VehicleTabs;
}(_react["default"].Component);
VehicleTabs.displayName = 'VehicleTabs';
VehicleTabs.defaultProps = {
  components: [],
  theme: {}
};
var _default = VehicleTabs;
exports["default"] = _default;